
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import moment from "moment";

const PageConst= {
  ACTION: {
    getScheduleTableStructure: {
      api: 'M0040TimeLimitService.doBrowseAll',
      input: {
        searchInfo: {
          not_time_division: 0
        }
      }
    },
    getScheduleTableStructureFull: {
      api: 'M0040TimeLimitService.doBrowseAll',
      input: {}
    },
    getStudentList: {
      api: 'T1010StudentBasicService.getStudentList',
      input: {
        searchInfo: {
          center_no: 0
        }
      }
    },
    submitStudentScheduleWeek: {
      api: 'T1030EntryScheduleWeekService.doSubmit',
      input: {
        searchInfo: {
          start_date: '2025-01-01',
          end_date: '2025-01-01',
          insert_list: [],
          delete_list: []
        }
      }
    },
    submitStudentSchedule: {
      api: 'T1031EntryScheduleService.doSubmit',
      input: {
        searchInfo: {
          start_date: '2025-01-01',
          end_date: '2025-01-01',
          insert_list: [],
          delete_list: []
        }
      }
    },
  },
}
/**
     * 指定した営業日後の日付を取得する
     * @param {number} workingDaysAfter - 何営業日後か
     * @param {string} baseDate - 基準日（YYYY-MM-DD形式）。省略時は今日
     * @returns {string|null} - 営業日後の日付（YYYY-MM-DD形式）、見つからない場合はnull
     */
function getWorkingDayAfter(state, workingDaysAfter, baseDate = null) {
  if (workingDaysAfter < 0)
    throw new Error('workingDaysAfter must be a non-negative integer');
  if (!Number.isInteger(workingDaysAfter))
    throw new Error('workingDaysAfter must be an integer');
  if (workingDaysAfter === 0 && baseDate) return moment(baseDate).format('YYYY-MM-DD');
  if (workingDaysAfter === 0 ) return moment().format('YYYY-MM-DD');
  if (state.t0050_calendar2.length === 0)
    throw new Error('t0050_calendar2 is empty');

  const base = baseDate ? moment(baseDate) : moment();
  if (!base.isValid())
    throw new Error('Invalid base date provided');

  let workingDays = 0;

  const debug = []

  let targetDate = null;
  for (let i = 0; i < state.t0050_calendar2.length; i++) {
    const date = state.t0050_calendar2[i];

    debug.push({
      schedule_date: date.schedule_date,
      closed_flag: date.closed_flag,
      workingDays,
      base: base.format('YYYY-MM-DD')
    });

    if (moment(date.schedule_date).isAfter(base) && date.closed_flag === 0) {
      workingDays++;
    }

    if (workingDays === workingDaysAfter + 1) {
      targetDate = date;
      break;
    }
  }
  console.table(debug)

  return targetDate ? targetDate.schedule_date : null;
}

const module = {
  state: {
    PageConst,

    setting: {
      // 単発：n営業日先以降の制限 , entry_type 2
      oneTimeOffLimit: 2,
      // 講習会：n営業日先以降の制限 , entry_type 3
      seminarLimit: 2,
      // 振替：n営業日先以降の制限 , entry_type 4
      changeLimit: 2,
    },

    // set default here
    searchInfo: {

    },
    // set default here
    // orderBy:PageConst.SEARCH_DEF.sortDef[0].value,
    // PgC30101
    init_PageformData: {
      selectedStudent: {},
      selectedSubject: {},
      classStartDate: moment().add(1, 'weeks').isoWeekday(1).format('YYYY-MM-DD'),

      classType: 1, // 1: レギュラー, 2: 単発, 3: 講習会
      insertScheduleList: [], // New Schedule
      deleteScheduleList: [], // Delete Schedule (entry_schedule_no)
      overallSubjectDate: [],// keep track all subject date
    },

    PageformData: {

    },

    // --- REFACTORING ---
    // t0050_calendar, t0060_seminar_calendar (event), t0061_regular_control (locked)
    t0050_calendar: [],
    /**
     * t0050_calendar is used for displaying the calendar range too hard to seperate
     */
    t0050_calendar2: [],
    selectedCell: null,

    t1030_entry_schedule_week: [], // regular
    t1031_entry_schedule: [],  // one time off and seminar
    t1032_not_attended_schedule: [],
    t3013_change_schedule: [],
    t1033_student_subject: [],
    t3010_schedule: [],
    t0060_seminar_calendar: [],
    t3015_cancel_schedule: [], // C30101_004
    //
    C30101_getCellTeacherCount: [],
    M1040_Schedule_Created_Date: null,
    C30101Student_getStudentSubject: [],

    isTargetMode: false,
    targetScheduleData: null,
    changeScheduleMode: false,
    // --- END REGION ----

    studentList: [],

    // 選択可能な科目 // 登録可能な科目 // 単発 // 講習会
    selectedSubject: [],

    scheduleTableStructure: [], // C30101-3
    scheduleTableStructureFull: [],
    calendarList: [], // C30101-4
    // scheduleList: [], // C30101-5
    // seminarCalendarList: [], // C30101-12

    // m1011_course_setting
    // - time_division
    DropDownTimeDivision: [
      { label: '90分', value: 0 },
      { label: '40分(前半)', value: 1 },
      { label: '40分(後半)', value: 2 },
    ],

    entry_type: null,
    class_type: null,
    entryType4Params: null,
    targetCell: {},

    t0060_seminar_calendar2: [],
    m3031_mail_setting: [],

    t0062_entry_control: [],

    C30101_getCalender:[],

    t0063_regular_schedule_control: [],
  },

  getters: {
    getWeekTh: (state) => (curDate, startDate) => {
      console.log(Math.floor( moment(curDate, "YYYY-MM-DD").diff(moment(startDate, "YYYY-MM-DD"),"days") / 7 ))
      return Math.floor( moment(curDate, "YYYY-MM-DD").diff(moment(startDate, "YYYY-MM-DD"),"days") / 7 );
    },
    getIsOpenSlot: (state,getters) => (date,timeLimitNo) => {
      return getters.getIsOpenTimeLimitSlot(date,timeLimitNo) || getters.getIsOpenSeminarSlot(date,timeLimitNo)
    },
    getIsOpenTimeLimitSlot: (state) => (date,timeLimitNo) => {
      // find target calendatList item using schedule_Date
      const targetSchedule = state.calendarList.find(item => item.schedule_date === date)
      if(!targetSchedule) throw new Error('Target schedule not found')
      if (targetSchedule.closed_flag) return false
      if (timeLimitNo >= targetSchedule.tstart_ime_limit_no && timeLimitNo <= targetSchedule.end_time_limit_no) return true
      return false
    },
    getIsOpenSeminarSlot: (state) => (date,timeLimitNo) => {
      const targetSchedule = state.calendarList.find(item => item.schedule_date === date)
      if(!targetSchedule) throw new Error('Target schedule not found')
      if (targetSchedule.closed_flag) return false
      if(state.t0060_seminar_calendar2.find(item =>
        item.schedule_start_date <= date &&
        item.schedule_end_date >= date &&
        item.start_time_limit_no <= timeLimitNo &&
        item.end_time_limit_no >= timeLimitNo
      )) return true
      return false
    },
    getTargetM3031MailSetting: (state)=> {
      switch (state.entry_type) {
        case 2:
          return state.m3031_mail_setting.find(item => item.notification_type === 1)
        case 3:
          return state.m3031_mail_setting.find(item => item.notification_type === 2)
        case 4:
          return state.m3031_mail_setting.find(item => item.notification_type === 3)
        default:
          return null
      }
    },
    getEditableDateRange(state) {
      console.log(state.entry_type)
      if ([2].includes(state.entry_type)) {
        return {
          startDate: moment(getWorkingDayAfter(state, state.setting.oneTimeOffLimit)),
          endDate: moment().add(1, 'month').endOf('month')
        };
      }
      if (
        ([3].includes(state.entry_type) || ([4].includes(state.entry_type) && state.class_type === 3)) &&
        state.t0060_seminar_calendar.length !== 0
      ) {
        const startDate = state.t0060_seminar_calendar.reduce((latestObj, currentObj) => {
          return moment(currentObj.schedule_start_date).isBefore(moment(latestObj.schedule_start_date)) ? currentObj : latestObj;
        });
        const endDate = state.t0060_seminar_calendar.reduce((latestObj, currentObj) => {
          return moment(currentObj.schedule_end_date).isAfter(moment(latestObj.schedule_end_date)) ? currentObj : latestObj;
        });
        return {
          startDate: moment().isBefore(startDate.schedule_start_date) ? moment(startDate.schedule_start_date) : moment(getWorkingDayAfter(state, state.setting.seminarLimit)),
          endDate: moment(endDate.schedule_end_date)
        }
      }
      if ([4].includes(state.entry_type)) {
        return {
          // startDate: moment(getWorkingDayAfter(state, state.setting.changeLimit, state.entryType4Params.schedule_date)),
          startDate: moment(getWorkingDayAfter(state, state.setting.changeLimit)),
          endDate: moment().add(1, 'month').endOf('month')
        };
      }
      // TODO: should throw error
      return {
        startDate: moment(),
        endDate: moment().add(1, 'month').endOf('month')
      }
      // throw new Error('Invalid entry_type for editable date range');
    },
    getCellTeacherCount:(state) =>(date, timeLimitNo) => {
      const key = `${date}_${timeLimitNo}`;
      const teacherCount = state.C30101_getCellTeacherCount[key];
      if (teacherCount)
        return teacherCount.rem_teacher_cnt;
      return 0;
    },
    isSeminarEntryDate (state) {
      return !!state.t0060_seminar_calendar.find(item => moment().startOf('day').isBetween(item.entry_start_date, item.entry_end_date, undefined, '[]'))
    },
    getT0062EntryControlMap(state) {
      const map = {};
      state.t0062_entry_control.forEach(item => {
        map[`${item.schedule_date}_${item.time_limit_no}`] = item;
      });
      return map;
    }
  },
  mutations: {
    insertEntrySchedule(state, payload) {
      state.t1030_entry_schedule_week = [...state.t1030_entry_schedule_week, payload]
    },
    insertt1030_entry_schedule_week(state, payload) {
      state.t1030_entry_schedule_week = [...state.t1030_entry_schedule_week, payload]
    },
    insertt1031_entry_schedule(state, payload) {
      state.t1031_entry_schedule = [...state.t1031_entry_schedule, payload]
    },
    insertt3013_change_schedule(state, payload) {
      state.t3013_change_schedule = [...state.t3013_change_schedule, payload]
    },
    insertt1032_not_attended_schedule(state, payload) {
      state.t1032_not_attended_schedule = [...state.t1032_not_attended_schedule,payload]
    },
    setEntry_type(state, payload) {
      state.entry_type = payload
    },
    insertt3010_schedule(state, payload) {
      state.t3010_schedule.push(payload)
    },
    resetState(state){
      state.init_PageformData = {
        selectedStudent: {},
        selectedSubject: {},
        classStartDate: moment().add(1, 'weeks').isoWeekday(1).format('YYYY-MM-DD'),

        classType: 1, // 1: レギュラー, 2: 単発, 3: 講習会
        insertScheduleList: [], // New Schedule
        deleteScheduleList: [], // Delete Schedule (entry_schedule_no)
        overallSubjectDate: [],// keep track all subject date
      }
    }
  },
  actions: {
    async initPgC30101StudentInit({ state, commit }, payload) {
      const res = await $this.$api.postData({
        data: {
          C30101Student_getStudentSubject: {
            api: 'T3010ScheduleService.C30101Student_getStudentSubject',
            input: {
              student_no: payload.student_no
            }
          },
          t0060_seminar_calendar: {
            api: 'T0060SeminarCalendarService.getAvailableSeminar'
          },
        }
      })

      commit('setState', {
        C30101Student_getStudentSubject: res.C30101Student_getStudentSubject.output,
        t0060_seminar_calendar: res.t0060_seminar_calendar.output,
      })
    },
    async initPgC30101StudentEntryType2({ state, commit }, payload) {
      const res = await $this.$api.postData({
        data: {
          T0050Calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          T1030EntryScheduleWeek: {
            api: 'T1030EntryScheduleWeekService.C30101_getEntryScheduleWeek',
            input: payload
          },
          T1031EntrySchedule: {
            api: 'T1031EntryScheduleService.C30101_getEntrySchedule',
            input: payload
          },
          T1033StudentSubject: {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          },
          T3010Schedule: {
            api: 'T3010ScheduleService.C30101_getSchedule',
            input: payload
          },
          T1032NotAttendedSchedule: {
            api: 'T1032NotAttendedScheduleService.C30101_getNotAttendedSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          T3013ChangeSchedule: {
            api: 'T3013ChangeScheduleService.C30101_getChangeSchedule',
            input: payload
          },
          T0050CalendarTeacherCount: {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          },
          M1040ScheduleCreatedDate: {
            api: 'M1040ScheduleCreatedDateService.C30101_getScheduleDateInfo',
            input: payload
          },
          T0060SeminarCalendar: {
            api: 'T0060SeminarCalendarService.C30101_getList',
            input: payload
          },
          T3015CancelSchedule: {
            api: 'T3015CancelScheduleService.C30101_getCancelSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          t0062_entry_control: {
            api: 'T0062EntryControlService.C30101Student_doBrowse',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          C30101_getCalender: {
            api: 'T0050CalendarService.C30101_getCalender',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },

          m3031_mail_setting: {
            api: 'M1031MailSettingService.C30101_doBrowse',
          },
          t0050_calendar2: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          C30101Student_getStudentSubject: {
            api: 'T3010ScheduleService.C30101Student_getStudentSubject',
            input: {
              student_no: payload.student_no,
              class_type: 2
            }
          },
          C30101Student_getStudentBasic: {
            api: 'T1010StudentBasicService.C30101Student_getStudentBasic',
            input: {
              student_no: payload.student_no,
            }
          },
          t0063_regular_schedule_control: {
            api: 'T0063RegularScheduleControlService.C30101_getRegularScheduleControl',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },
        }
      });

      commit('setState', {
        C30101_getCalender: res.C30101_getCalender.output,
        C30101_getCellTeacherCount: res.T0050CalendarTeacherCount.output,
        M1040_Schedule_Created_Date: res.M1040ScheduleCreatedDate.output,
        m3031_mail_setting: res.m3031_mail_setting.output,
        t0050_calendar2: res.t0050_calendar2.output,
        t0050_calendar: res.T0050Calendar.output,
        t0060_seminar_calendar: res.T0060SeminarCalendar.output,
        t0062_entry_control: res.t0062_entry_control.output,
        t1030_entry_schedule_week: res.T1030EntryScheduleWeek.output,
        t1031_entry_schedule: res.T1031EntrySchedule.output,
        t1032_not_attended_schedule: res.T1032NotAttendedSchedule.output,
        t1033_student_subject: res.T1033StudentSubject.output,
        t3010_schedule: res.T3010Schedule.output,
        t3013_change_schedule: res.T3013ChangeSchedule.output,
        t3015_cancel_schedule: res.T3015CancelSchedule.output,
        // C30101 Entry Type 2
        entry_type: 2,
        C30101Student_getStudentSubject: res.C30101Student_getStudentSubject.output,
        PageformData: {
          selectedStudent: res.C30101Student_getStudentBasic.output,
        },
        t0063_regular_schedule_control: res.t0063_regular_schedule_control.output,
      });
    },
    async initPgC30101StudentEntryType3({ state, commit }, payload) {
      const res = await $this.$api.postData({
        data: {
          T0050Calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          T1030EntryScheduleWeek: {
            api: 'T1030EntryScheduleWeekService.C30101_getEntryScheduleWeek',
            input: payload
          },
          T1031EntrySchedule: {
            api: 'T1031EntryScheduleService.C30101_getEntrySchedule',
            input: payload
          },
          T1033StudentSubject: {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          },
          T3010Schedule: {
            api: 'T3010ScheduleService.C30101_getSchedule',
            input: payload
          },
          T1032NotAttendedSchedule: {
            api: 'T1032NotAttendedScheduleService.C30101_getNotAttendedSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          T3013ChangeSchedule: {
            api: 'T3013ChangeScheduleService.C30101_getChangeSchedule',
            input: payload
          },
          T0050CalendarTeacherCount: {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          },
          M1040ScheduleCreatedDate: {
            api: 'M1040ScheduleCreatedDateService.C30101_getScheduleDateInfo',
            input: payload
          },
          T0060SeminarCalendar: {
            api: 'T0060SeminarCalendarService.C30101_getList',
            input: payload
          },
          T3015CancelSchedule: {
            api: 'T3015CancelScheduleService.C30101_getCancelSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          t0062_entry_control: {
            api: 'T0062EntryControlService.C30101Student_doBrowse',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          C30101_getCalender: {
            api: 'T0050CalendarService.C30101_getCalender',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },

          m3031_mail_setting: {
            api: 'M1031MailSettingService.C30101_doBrowse',
          },
          t0050_calendar2: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          C30101Student_getStudentSubject: {
            api: 'T3010ScheduleService.C30101Student_getStudentSubject',
            input: {
              student_no: payload.student_no,
              class_type: 3
            }
          },
          C30101Student_getStudentBasic: {
            api: 'T1010StudentBasicService.C30101Student_getStudentBasic',
            input: {
              student_no: payload.student_no,
            }
          },
          t0063_regular_schedule_control: {
            api: 'T0063RegularScheduleControlService.C30101_getRegularScheduleControl',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },
        }
      });

      commit('setState', {
        C30101_getCalender: res.C30101_getCalender.output,
        C30101_getCellTeacherCount: res.T0050CalendarTeacherCount.output,
        M1040_Schedule_Created_Date: res.M1040ScheduleCreatedDate.output,
        m3031_mail_setting: res.m3031_mail_setting.output,
        t0050_calendar2: res.t0050_calendar2.output,
        t0050_calendar: res.T0050Calendar.output,
        t0060_seminar_calendar: res.T0060SeminarCalendar.output,
        t0062_entry_control: res.t0062_entry_control.output,
        t1030_entry_schedule_week: res.T1030EntryScheduleWeek.output,
        t1031_entry_schedule: res.T1031EntrySchedule.output,
        t1032_not_attended_schedule: res.T1032NotAttendedSchedule.output,
        t1033_student_subject: res.T1033StudentSubject.output,
        t3010_schedule: res.T3010Schedule.output,
        t3013_change_schedule: res.T3013ChangeSchedule.output,
        t3015_cancel_schedule: res.T3015CancelSchedule.output,
        // C30101 Entry Type 3
        entry_type: 3,
        C30101Student_getStudentSubject: res.C30101Student_getStudentSubject.output,
        PageformData: {
          selectedStudent: res.C30101Student_getStudentBasic.output,
        },
        t0063_regular_schedule_control: res.t0063_regular_schedule_control.output,
      });
    },
    async initPgC30101StudentEntryType4({ state, commit }, payload) {
      const res = await $this.$api.postData({
        data: {
          T0050Calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          T1030EntryScheduleWeek: {
            api: 'T1030EntryScheduleWeekService.C30101_getEntryScheduleWeek',
            input: payload
          },
          T1031EntrySchedule: {
            api: 'T1031EntryScheduleService.C30101_getEntrySchedule',
            input: payload
          },
          T1033StudentSubject: {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          },
          T3010Schedule: {
            api: 'T3010ScheduleService.C30101_getSchedule',
            input: payload
          },
          T1032NotAttendedSchedule: {
            api: 'T1032NotAttendedScheduleService.C30101_getNotAttendedSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          T3013ChangeSchedule: {
            api: 'T3013ChangeScheduleService.C30101_getChangeSchedule',
            input: payload
          },
          T0050CalendarTeacherCount: {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          },
          M1040ScheduleCreatedDate: {
            api: 'M1040ScheduleCreatedDateService.C30101_getScheduleDateInfo',
            input: payload
          },
          T0060SeminarCalendar: {
            api: 'T0060SeminarCalendarService.C30101_getList',
            input: payload
          },
          T3015CancelSchedule: {
            api: 'T3015CancelScheduleService.C30101_getCancelSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          t0062_entry_control: {
            api: 'T0062EntryControlService.C30101Student_doBrowse',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          C30101_getCalender: {
            api: 'T0050CalendarService.C30101_getCalender',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },

          m3031_mail_setting: {
            api: 'M1031MailSettingService.C30101_doBrowse',
          },
          t0050_calendar2: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          C30101Student_getStudentBasic: {
            api: 'T1010StudentBasicService.C30101Student_getStudentBasic',
            input: {
              student_no: payload.student_no,
            }
          },
          t0063_regular_schedule_control: {
            api: 'T0063RegularScheduleControlService.C30101_getRegularScheduleControl',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },
        }
      });

      commit('setState', {
        C30101_getCalender: res.C30101_getCalender.output,
        C30101_getCellTeacherCount: res.T0050CalendarTeacherCount.output,
        M1040_Schedule_Created_Date: res.M1040ScheduleCreatedDate.output,
        m3031_mail_setting: res.m3031_mail_setting.output,
        t0050_calendar2: res.t0050_calendar2.output,
        t0050_calendar: res.T0050Calendar.output,
        t0060_seminar_calendar: res.T0060SeminarCalendar.output,
        t0062_entry_control: res.t0062_entry_control.output,
        t1030_entry_schedule_week: res.T1030EntryScheduleWeek.output,
        t1031_entry_schedule: res.T1031EntrySchedule.output,
        t1032_not_attended_schedule: res.T1032NotAttendedSchedule.output,
        t1033_student_subject: res.T1033StudentSubject.output,
        t3010_schedule: res.T3010Schedule.output,
        t3013_change_schedule: res.T3013ChangeSchedule.output,
        t3015_cancel_schedule: res.T3015CancelSchedule.output,
        // C30101 Entry Type 4
        entry_type: 4,
        PageformData: {
          selectedStudent: res.C30101Student_getStudentBasic.output,
        },
        t0063_regular_schedule_control: res.t0063_regular_schedule_control.output,
      });
    },
    async initState ({ state, commit }, payload) {
      state.PageformData = { ...state.init_PageformData }

      const res = await $this.$api.postData({
        data: {
          scheduleTableStructure: PageConst.ACTION.getScheduleTableStructure,
          scheduleTableStructureFull: PageConst.ACTION.getScheduleTableStructureFull,
          studentList: {
            ...PageConst.ACTION.getStudentList,
            input: {
              searchInfo: {
                student_no: payload.student_no
              }
            }
          },
          m3031_mail_setting: {
            api: 'M1031MailSettingService.C30101_doBrowse',
          },
          // init fetch for entry_type 4
          t0050_calendar2: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          t0060_seminar_calendar: {
            api: 'T0060SeminarCalendarService.getAvailableSeminar'
          },
          t0060_seminar_calendar2: {
            api: 'T0060SeminarCalendarService.C30101_getList',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },
          t0050_calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          t0062_entry_control: {
            api: 'T0062EntryControlService.C30101Student_doBrowse',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
        }
      })

      commit('setState', {
        scheduleTableStructure: res.scheduleTableStructure.output,
        scheduleTableStructureFull: res.scheduleTableStructureFull.output,
        studentList: res.studentList.output,
        m3031_mail_setting: res.m3031_mail_setting.output,
        t0050_calendar2: res.t0050_calendar2.output,
        t0060_seminar_calendar: res.t0060_seminar_calendar.output,
        t0060_seminar_calendar2: res.t0060_seminar_calendar2.output,
        t0050_calendar: res.t0050_calendar.output,
        t0062_entry_control: res.t0062_entry_control.output,
      })

    },
    async initState2({ state, commit }, payload) {
      const res = await $this.$api.postData({
        data: {
          t0050_calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          t1030_entry_schedule_week: {
            api: 'T1030EntryScheduleWeekService.C30101Student_getEntryScheduleWeek',
            input: payload
          },
          t1031_entry_schedule: {
            api: 'T1031EntryScheduleService.C30101Student_getEntrySchedule',
            input: payload
          },
          t1033_student_subject: {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          },
          t3010_schedule: {
            api: 'T3010ScheduleService.C30101Student_getSchedule',
            input: {
              ...payload,
              entry_type4_t3010_ids: state.entryType4Params? state.entryType4Params.t3010_data.id : null
            }
          },
          t1032_not_attended_schedule: {
            api: 'T1032NotAttendedScheduleService.C30101_getNotAttendedSchedule',
            input: payload
          },
          t3013_change_schedule: {
            api: 'T3013ChangeScheduleService.C30101_getChangeSchedule',
            input: payload
          },
          C30101_getCellTeacherCount: {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          },
          M1040_Schedule_Created_Date: {
            api: 'M1040ScheduleCreatedDateService.C30101_getScheduleDateInfo',
            input: payload
          },
          calendarList: {
            api: 'T0050CalendarService.getCalendarByRange',
            input: { searchInfo: payload }
          },
          t3015_cancel_schedule: {
            api: 'T3015CancelScheduleService.C30101_getCancelSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          C30101Student_getStudentSubject: {
            api: 'T3010ScheduleService.C30101Student_getStudentSubject',
            input: {
              student_no: payload.student_no
            }
          }
        }
      })

      commit('setState', {
        t0050_calendar: res.t0050_calendar.output,
        t1030_entry_schedule_week: res.t1030_entry_schedule_week.output,
        t1031_entry_schedule: res.t1031_entry_schedule.output,
        t1033_student_subject: res.t1033_student_subject.output,
        t3010_schedule: res.t3010_schedule.output,
        t1032_not_attended_schedule: res.t1032_not_attended_schedule.output,
        t3013_change_schedule: res.t3013_change_schedule.output,
        C30101_getCellTeacherCount: res.C30101_getCellTeacherCount.output,
        M1040_Schedule_Created_Date: res.M1040_Schedule_Created_Date.output,
        calendarList: res.calendarList.output,
        t3015_cancel_schedule: res.t3015_cancel_schedule.output,
        C30101Student_getStudentSubject: res.C30101Student_getStudentSubject.output
      })
    },
    // ----------------- REFACTORING -----------------
    async C30101_getSchedule({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          }
        ]
      })

      commit('setState', {
        t0050_calendar: result[0].output,
      })

    },
    async C30101_getEntryScheduleWeek({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T1030EntryScheduleWeekService.C30101_getEntryScheduleWeek',
            input: payload
          }
        ]
      })

      commit('setState', {
        t1030_entry_schedule_week: result[0].output,
      })

    },
    async C30101_getEntrySchedule({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T1031EntryScheduleService.C30101_getEntrySchedule',
            input: payload
          }
        ]
      })

      commit('setState', {
        t1031_entry_schedule: result[0].output,
      })

    },
    async C30101_doBrowseByStudentNo({ state, commit }, payload) {
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          }
        ]
      })

      commit('setState', {
        t1033_student_subject: res[0].output,
      })

    },
    async C30101_getT3010Schedule({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T3010ScheduleService.C30101_getSchedule',
            input: payload
          }
        ]
      })

      commit('setState', {
        t3010_schedule: result[0].output,
      })

    },
    async C30101_getNotAttendedSchedule({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T1032NotAttendedScheduleService.C30101_getNotAttendedSchedule',
            input: payload
          }
        ]
      })

      commit('setState', {
        t1032_not_attended_schedule: result[0].output,
      })

    },
    async C30101_getChangeSchedule({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T3013ChangeScheduleService.C30101_getChangeSchedule',
            input: payload
          }
        ]
      })

      commit('setState', {
        t3013_change_schedule: result[0].output,
      })

    },
    async C30101_submit({ state }, payload) {
      const filter = (item) => {
        return item._action
      }
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T1030EntryScheduleWeekService.C30101_submit',
            input: {
              student_no: state.PageformData.selectedStudent.student_no,
              belongs_center_no: state.PageformData.selectedStudent.belongs_center_no,
              t1030_entry_schedule_week: state.t1030_entry_schedule_week.filter(filter),
              t1031_entry_schedule: state.t1031_entry_schedule.filter(filter),
              t1032_not_attended_schedule: state.t1032_not_attended_schedule.filter(filter),
              t3013_change_schedule: state.t3013_change_schedule.filter(filter),
              t1033_student_subject: state.t1033_student_subject.filter(filter),
              t3010_schedule: state.t3010_schedule.filter(filter),
              t3015_cancel_schedule: state.t3015_cancel_schedule.filter(filter),
              payload,
            }
          }
        ],
        databaseDiff:{
          tables: [
            't1030_entry_schedule_week',
            't1031_entry_schedule',
            't1032_not_attended_schedule',
            't3013_change_schedule',
            't1033_student_subject',
            't3010_schedule',
            't3015_cancel_schedule',
          ]
        }
      })
      return result[0].output;
    },
    async C30101_StudentConfirmationEmail({ state }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'M1031MailSettingService.C30101_StudentConfirmationEmail',
            input: payload
          }
        ]
      })

      return result[0].output;
    },
    async C30101_getCellTeacherCount({ state, commit }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          }
        ]
      })

      commit('setState', {
        C30101_getCellTeacherCount: result[0].output,
      })
    },
    checkWithDateRange({ state,getters }, payload){
      let isWithRange = false
      const targetDate = moment(payload, 'YYYY-MM-DD');
      const {startDate,endDate}= getters.getEditableDateRange
      isWithRange = targetDate.isBetween(startDate, endDate, 'day', '[]')
      return isWithRange
    },
    getCellDayInfo({ state }, dataKey) {
      const result = state.t0050_calendar.find(item => item.schedule_date === dataKey.split('_')[0]) || {}
      return JSON.parse(JSON.stringify(result))
    },
    getCellTimeSlot({ state }, dataKey) {
      const result = $this.$store.getters['Auth/Auth_getTimeLimit_without0'].find(item => item.time_limit_no === parseInt(dataKey.split('_')[1])) || {}
      result.time_limit_group = parseInt(result.time_limit_no.toString().slice(0, -1)) || 0
      return JSON.parse(JSON.stringify(result))
    },
    async C30101Student_getCurrentSeminar({ state }, payload) {
      const result = await $this.$api.postData({
        data: [
          {
            api: 'T0060SeminarCalendarService.C30101Student_getCurrentSeminar',
            input: payload
          }
        ]
      })
      return result[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
